__turbopack_context__.v({
  "appType": "one-system-module__Lfib8G__appType",
  "claret": "one-system-module__Lfib8G__claret",
  "display": "one-system-module__Lfib8G__display",
  "page": "one-system-module__Lfib8G__page",
  "square": "one-system-module__Lfib8G__square",
});
